import {useMemo} from "react";
import {createTable, RenderingPresetType, TableHeaderSpec} from "../../../../../components/table/CreateTable.tsx";
import {Transaction} from "../../TransactionsTable.tsx";
import {CustomerBankAccount} from "../../../../../api/customerBankAccounts/CustomerBankAccount.ts";
import {BankAccountLogo} from "../../../../../components/general/BankAccountLogo.tsx";
import GLAPill from "../../../../../components/specific/GLAPill.tsx";

interface Props {
    transactions: Array<Transaction>,
    bankAccounts: Array<CustomerBankAccount>,
}

export function DashboardRecentTransactionsTable({
                                                     transactions,
                                                     bankAccounts,
                                                 }: Props) {
    const bankAccountsById = useMemo(
        () => new Map(bankAccounts.map(account => [account.id, account])),
        [bankAccounts],
    );

    const tableSpec: TableHeaderSpec<Transaction> = {
        title: `${transactions.length} Transactions`,
        columns: [
            {
                name: 'Relatie',
                field: 'relationName',

                customRender: (row: Transaction) => (
                    <div className="text-sm text-gray-500">{row.relationName} <br/> {row.relationIBAN}</div>
                )
            },
            {
                name: 'Bedrag',
                field: 'value',
                style: {
                    widthMultiplier: 0.5
                },
                renderingPreset: RenderingPresetType.MoneyColorAid
            },
            {
                name: 'Omschrijving',
                field: 'desc'
            },
            {
                name: 'Datum',
                field: 'bookingDate',
                style: {
                    nowrap: true,
                    widthMultiplier: 0.75
                },
            },
            {
                name: "Categorie",
                field: 'generalLedgerAccountId',
                style: {
                    nowrap: true,
                    widthMultiplier: 1.5
                },
                customRender: (row: Transaction) => (
                    <GLAPill
                        icon={row.generalLedgerAccount.icon}
                        label={row.generalLedgerAccount.cashflow_subcategory_nl}
                    />
                )
            },
            {
                name: 'Bank',
                field: 'accountId',
                customRender: (row: Transaction) => {

                    const bankAccount = bankAccountsById.get(row.accountId)

                    return (
                        <div className="flex items-center gap-x-2 whitespace-nowrap">
                            <BankAccountLogo logoUrl={bankAccount?.logoUrl} accountType={bankAccount?.accountType} creditCardNumberPrefix={bankAccount?.creditCardNumberPrefix} className="h-6 w-6" />
                            <span>{bankAccount?.ownerName}</span>
                        </div>
                    )
                }
            },
        ],
    }


    const TableComponent = createTable<Transaction>(transactions, tableSpec)

    return (
        <>
            {TableComponent()}
        </>
    )
}
